import {View} from "./View"
export const LinkedExternalAcctLink=  () => {
    return(
        <View />
    )
}
